// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1___66668c48be1176440ff","cls2":"CreateComment-cls2___bd0fd1be434aa4dbd3c CreateComment-cls1___66668c48be1176440ff"};